module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_36"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478525"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter Eight")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Zen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca carefully eyed the robes of the monk sitting across from her and determined that he belonged to the Zen sect of Buddhism. A calmness emanated from deep within him and soon her brain flooded with questions. Why did Alexander disturb her so and why did every fiber of her body tell her to trust him, especially after what he had just done? What in the world was she doing here? But mostly she wanted to know, who was this fellow named Alexander?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("She looked deep into the monk’s eyes and he breathed deeply, drawing her in. His body remained absolutely motionless, seemingly untouched by the material world. Rebecca intuitively perceived that he was in balance with the life forces around him and felt her own energy aligning with his. He waited patiently for her questions.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Searching her psyche, one question resonated and floated to the surface of her consciousness. She was surprised to hear herself ask, “What is Buddhism?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("His hand swept inches above the pristine wood floor. “This is it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Confused, she actually found herself looking at the floor. “What is it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Buddhism,” was all he answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca glanced at Alexander who refused eye contact and again she interpreted this as a gesture of trust -- not arrogance.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Could you explain to me in a way so that I may understand?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes,” the monk answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("She waited as silence enveloped the room. From outside, a child giggled and someone admired a candle. The land of lit lanterns and celebrating citizens had so quickly fallen away.")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Then suddenly, she understood his silence — he had already answered her question in a way that she")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("should comprehend.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca stated, “I study quantum physics.” Hoping not to offend, she asked, “Do you know what that is?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The monk looked deeply into her violet eyes and said the one thing she had not anticipated, “It is Buddhism.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Her")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("mind went blank and it took her a second to reboot. In that moment, the Zen monk added, “Particles in your quantum physics are sometimes there, sometimes not. Correct? You even call them virtual particles, just as in Buddhism, reality is not always")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("reality.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Trying to grasp what he said, Rebecca unconsciously nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Particles that have no apparent means of communication somehow pass messages faster than the speed of light through the ether to one another. Correct?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Completely befuddled, Rebecca answered, “Yes. Entangled photons, what Einstein called, “Spooky action at a distance”.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Do your calculations not show that this information between photons may actually travel 10,000 times faster than light and that many dimensions are as close to us as a width of a hair?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Astounded at his breadth of knowledge, she muttered, “Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The strange Zen master smiled benevolently. “Buddha is not so far away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Are you saying that what we are learning in quantum physics is confirming what Buddhists have known for thousands of years?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He clasped his hands together in prayer and whispered, “This is it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("For a moment, she found herself understanding and then rejected the concept. Rebecca’s powerful mind churned new information into a fundamental question. It would")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("question")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("the very fabric of reality, the very thing that we are a part of. It would mean that we would have to ask ourselves -- Do we really exist?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca finally commented, “My watching of the stars predicts that a great soul is about to leave this universe. Do you know anything about this?” Rebecca noticed that Alexander appeared surprised that she dabbled in astrology.")]), _c('span', {
    staticClass: "calibre33"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“What can you tell me?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Everything.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“My star charts foretell a great loss for all mankind. Are you saying that this so?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“This soul, will it travel to one of these other dimensions, another universe, another brane as we call it in physics?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes. But this individualized soul may also choose to return.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Shocked, Rebecca blurted, “This soul has a choice?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Before asking her biggest question, she looked in the direction of Alexander. “Why do I trust him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("simple monk who seemed to hold all the answers of the universe glanced at his male guest, and then back to Rebecca. “Your differences are infinitesimal compared to your similarities.” He smiled, enjoying their confusion at his response and then broke out laughing. “Some would call you two -- the God particle.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca knew he referred to the Higgs Boson, a bit of nothing that humanity had spent billions to find. This monk’s knowledge of her field of expertise, Chaos Theory, was impressive. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("For the first time since her abduction, Rebecca spoke softly to Alexander, “Who are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Who I am is no simple question, nor easy to answer. I am many things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Then let me try to make it easy for you. What do you do for a living?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Some would call me a consultant. I call myself a private contractor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca’s face revealed uncertainty. “For whom do you consult?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander shifted uncomfortably and glanced at the Zen monk who remained silent. “I consult for many international companies.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca felt she was getting the upper hand for the first time since leaving her bookstore. “Then with whom do you contract privately?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander sighed. “It is not easy to answer your questions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander hesitated and finally responded, his words cutting through the quiet, “For reasons of national security.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Surprisingly, this did not catch Rebecca totally off-guard. Recognizing the power of the monk’s silence, she took advantage of the quiet. It felt as if the room itself waited for more information and she enjoyed watching this alpha-male squirm.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Moments passed and Alexander knew he owed her an answer; he had after all, dragged her into this room against her will. His eyes averted her gaze and he continued, “I work for the intelligence community -- specifically the EPA.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("That did surprise Rebecca, the Environmental Protection Agency? That wasn’t exactly the FBI. Was the EPA even part of the intelligence community?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“You might say that I conduct intelligence assessments.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca pushed her tactical advantage and used guilt. “Since you forced me here, I’m sure you won’t mind explaining exactly what that means.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("A small twitch creased Alexander’s face and Rebecca noticed")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("an almost imperceptible smile cross the monk’s face. He too seemed to enjoy watching Alexander squirm, knowing that Alexander’s moral compass now bent to the will of the woman. Rebecca could successfully get answers from him that old Cold War Soviet interrogators could not have. The Zen Buddhist was pleased that his plan was working.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v(" “I gather information, not unlike a quantum scientist. I then extract the truth and reduce ambiguity that sometimes has been deliberately created by highly intelligent people.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca smiled. “You are an analyst.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“You make sure that the right people get accurate information for their decision making.” Rebecca’s eyes widen with a thought. “Do you also work for The Company? The CIA?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander’s eyes went cold and Rebecca realized that she had gone one question too far. In order to get the")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("information,")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("she needed before he closed down, she quickly asked,")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Why are you here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The answer was in his eyes. He and the monk looked at one another and Rebecca gasped. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Her eyes swelled with tears and she asked the big question, “Who is about to die?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The monk whispered, “Why do you always answer questions with questions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“What do you mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“You already know the answer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Her head nearly exploded with realization and tears streamed down her cheeks. “No! The world is not ready for his death. Not yet. It’s too soon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander reached across the expanse between the two of them and gently held her hand. “We have a lot to accomplish before this fateful event occurs.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre25"
  }, [_c('span', {
    staticClass: "calibre16",
    attrs: {
      "id": "calibre_pb_37"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0880d17f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_011.vue
// module id = 93
// module chunks = 0